import React from 'react';
import { Container, Row, Col, Card, Button, Alert, Spinner, Badge } from 'react-bootstrap';
import { Cloud, CheckCircle, XCircle, ArrowClockwise } from 'react-bootstrap-icons';
import { useTestAWSConnectionQuery } from '../services/api';
import { useAccount } from '../contexts/AccountContext';

const AWSConnectionTest = () => {
  const { selectedAccount, isAllAccountsSelected } = useAccount();
  const { 
    data: connectionStatus, 
    error, 
    isLoading: testing, 
    refetch 
  } = useTestAWSConnectionQuery();

  const getStatusIcon = () => {
    if (testing) return <Spinner size="sm" className="me-2" />;
    if (connectionStatus?.data?.connected) return <CheckCircle className="me-2 text-success" />;
    if (connectionStatus?.data && !connectionStatus.data.connected) return <XCircle className="me-2 text-danger" />;
    return <Cloud className="me-2" />;
  };

  const getStatusColor = () => {
    if (connectionStatus?.data?.connected) return 'success';
    if (connectionStatus?.data && !connectionStatus.data.connected) return 'danger';
    return 'secondary';
  };

  return (
    <Card className="h-100">
      <Card.Header className="bg-primary text-white">
        <div className="d-flex justify-content-between align-items-center">
          <h5 className="mb-0">
            <Cloud className="me-2" />
            AWS Connection Test
          </h5>
          {!isAllAccountsSelected && selectedAccount?.alias && (
            <Badge bg="light" text="dark">
              {selectedAccount.alias}
            </Badge>
          )}
        </div>
      </Card.Header>
      <Card.Body>
        <Alert variant="info" className="mb-3">
          <strong>🛡️ SAFETY MODE ENABLED</strong><br/>
          <small>READ-ONLY mode - no modifications to AWS resources.</small>
        </Alert>

              {error && (
                <Alert variant="danger" className="mb-4">
                  <strong>Error:</strong> {error.message || 'Connection failed'}
                </Alert>
              )}

              {connectionStatus?.data && (
                <Alert variant={getStatusColor()} className="mb-4">
                  <div className="d-flex align-items-center">
                    {getStatusIcon()}
                    <div>
                      <strong>{connectionStatus.data.message}</strong>
                      {connectionStatus.data.connected && (
                        <div className="mt-2">
                          <small>
                            SES Identities: {connectionStatus.data.sesIdentities} | 
                            S3 Bucket: {connectionStatus.data.s3BucketStatus}
                          </small>
                          {connectionStatus.data.safetyMode && (
                            <div className="mt-1">
                              <small className="text-info">
                                <strong>🛡️ {connectionStatus.data.safetyMode}</strong>
                              </small>
                            </div>
                          )}
                        </div>
                      )}
                      {connectionStatus.data.error && (
                        <div className="mt-2">
                          <small><strong>Error:</strong> {connectionStatus.data.error}</small>
                        </div>
                      )}
                    </div>
                  </div>
                </Alert>
              )}

              <div className="d-flex gap-2">
                <Button 
                  variant="primary" 
                  size="sm"
                  onClick={() => refetch()} 
                  disabled={testing}
                >
                  {testing ? (
                    <>
                      <Spinner size="sm" className="me-1" />
                      Testing...
                    </>
                  ) : (
                    <>
                      <ArrowClockwise className="me-1" />
                      Test Connection
                    </>
                  )}
                </Button>
              </div>
            </Card.Body>
          </Card>
  );
};

export default AWSConnectionTest;
